import {Component, inject} from '@angular/core';
import {RepoService} from "../services/repo.service";
import {Rating} from "../models/rating";
import {Chart, ChartData} from "chart.js/auto";
import {RatingService} from "../services/rating-service";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-app-rating',
  imports: [
    FormsModule
  ],
  templateUrl: './app-rating.component.html',
  styleUrl: './app-rating.component.css'
})
export class AppRatingComponent {

  repoService = inject(RepoService)
  ratingService = inject(RatingService);
  iosRatings: Rating[];
  androidRatings: Rating[];
  latestIOSRating: number;
  latestAndroidRating: number;
  dropdownYears: string[];
  selectedYear: string = 'all';

  barChart: Chart;
  private data: ChartData;

  constructor() {
  }

  async ngOnInit() {
    this.iosRatings = await this.ratingService.getIOSAppRatings();
    this.androidRatings = await this.ratingService.getAndroidAppRatings();

    this.dropdownYears = this.ratingService.getDropdownValues(this.iosRatings, this.androidRatings);


    this.latestIOSRating = this.iosRatings[0].rating;
    this.latestAndroidRating = this.androidRatings[0].rating;

    this.generateChart(this.iosRatings, this.androidRatings);
  }


  generateChart(iosRatings: Rating[], androidRatings: Rating[]) {

    if (this.barChart) {
      this.barChart.destroy()
    }

    const datesSet = Array.from(new Set([...iosRatings.map((ios) => ios.date), ...androidRatings.map((android) => android.date)]));
    const xAxis = this.ratingService.getXAxis(this.selectedYear, datesSet);

    this.ratingService.sortDates(datesSet);


    const iosRatingMap = new Map(iosRatings.map((i) => [i.date, i.rating]));
    const androidRatingMap = new Map(androidRatings.map((a) => [a.date, a.rating]));


    this.data = {
      labels: xAxis,
      datasets: [
        {
          backgroundColor: "#0000c2",
          label: 'IOS',
          data: this.ratingService.getYAxis(xAxis, iosRatingMap),
          borderWidth: 1
        },
        {
          backgroundColor: "#4596F7",
          label: 'Android',
          data: this.ratingService.getYAxis(xAxis, androidRatingMap),
          borderWidth: 1
        }
      ]
    };


    this.barChart = new Chart('ratingChart', {
      type: 'bar',
      data: this.data,
      options: {
        responsive: true,
        maintainAspectRatio: false,
      }
    });
  }


  onYearChanged() {
    this.barChart.destroy();
    this.generateChart(this.iosRatings, this.androidRatings);

  }


}
